const isHybrid = navigator.userAgent.includes('Skybrid');
const home = 'global';

const toBoolean = (raw, fallback = true) => {
	if (raw === undefined) {
		return fallback;
	}
	return (Array.isArray(raw) ? raw[0] : raw) !== 'false';
};

const commonRoutes = [
	{
		path: '/:pathMatch(.*)*', // Cambiado para Vue Router 4
		redirect: { name: 'login' },
	},
	{
		path: '/entry',
		name: 'entry',
	},
	{
		path: '/',
		name: 'login',
		component: () => import('@views/v-cbnk-login.vue'),
	},
	{
		path: '/home',
		name: 'home',
		redirect: { name: home },
	},
	{
		path: '/sso-rsi-form/:userId/:tokenSSO/:usuarioAgente?',
		props: { default: true },
		name: 'sso-rsi-form',
		components: {
			default: () => import(/* webpackChunkName: "v-sso-rsi-form" */ '@views/v-sso-rsi-form'),
		},
	},
];

export default [
	...commonRoutes,
	{
		path: '/blocking-communication/',
		name: 'blocking-communication',
		props: { default: true },
		components: {
			default: () => import('@views/v-cbnk-blocking-communication.vue'),
		},
		children: [
			{
				path: 'acceptance',
				name: 'acceptance',
				components: {
					default: () => import('@views/v-cbnk-acceptances.vue'),
				},
			},
		],
	},
	{
		path: '/blocking-open-funcionality-campaign/',
		name: 'blocking-open-funcionality-campaign',
		props: {
			primary: true,
			secondary: true,
		},
		components: {
			default: () => import('@views/v-blocking-open-funcionality-campaign'),
		},
	},
	{
		path: '/request-registered/',
		name: 'request-registered',
		props: {
			primary: true,
		},

		components: {
			default: () => import('@views/v-request-registered'),
		},
	},
	{
		path: '/main/',
		name: 'main',
		props: { default: true },
		components: {
			default: () => import('@views/v-cbnk-main.vue'),
		},
		children: [
			{
				path: 'sso-rsi',
				name: 'sso-rsi',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
				components: {
					primary: () => import(/* webpackChunkName: "v-sso-rsi" */ '@views/v-sso-rsi'),
				},
			},
			{
				path: 'sso-lighthouse/:operative/:productId',
				name: 'sso-lighthouse',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
				components: {
					primary: () => import('@views/v-sso-lighthouse'),
				},
			},
			{
				path: 'linea-caminos',
				name: 'linea-caminos',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
				components: {
					primary: () =>
						import(/* webpackChunkName: "v-linea-caminos" */ '@views/v-linea-caminos'),
				},
			},
			{
				path: 'bolsa-caminos',
				name: 'bolsa-caminos',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
				components: {
					primary: () => import('@views/v-bolsa-caminos'),
				},
			},
			// 		{
			// 			path: 'tax-info',
			// 			name: 'tax-info',
			// 			props: { primary: { action: 'InformacionFiscal' } },
			// 			meta: {
			// 				isFullWidth: true,
			// 				transition: 'fade',
			// 			},
			// 			components: {
			// 				primary: () =>
			// 					import(
			// 						/* webpackChunkName: "v-linea-caminos" */ '@views/v-linea-caminos'
			// 					),
			// 			},
			// 		},
			{
				path: 'global',
				name: 'global',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					entryPoint: isHybrid,
				},
				components: {
					primary: () => import('@views/v-global.vue'),
				},
			},
			{
				path: 'sso-card-management',
				name: 'sso-card-management',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					entryPoint: isHybrid,
					isNavDisabled: true,
				},
				components: {
					primary: () => import('@views/v-sso-card-management.vue'),
				},
			},
			{
				path: 'investment-account/:familyId/:productId',
				name: 'cbnk-investment-account',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-investment-account'),
				},
			},
			{
				path: 'product-confirming/:familyId/:productId',
				name: 'cbnk-product-confirming',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-confirming'),
				},
			},
			{
				path: 'investment-account/:familyId/:productId',
				name: 'investment-account',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
				components: {
					primary: () => import('@views/v-investment-account'),
				},
			},
			{
				path: 'apple-pay/:productId',
				name: 'apple-pay',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-apple-pay'),
				},
			},
			{
				path: 'google-pay/:productId',
				name: 'google-pay',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-google-pay'),
				},
			},
			{
				path: '/product-detail/:productId',
				name: 'products-detail',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-fam-products-detail'),
				},
			},
			{
				path: 'refund-request/:productId?',
				name: 'refund-request',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-refund-request'),
				},
			},
			{
				path: 'marketplace',
				name: 'marketplace',
				props: { primary: true },
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-marketplace'),
				},
			},
			{
				path: 'marketplace/category/:categoryId/:categoryName?',
				name: 'marketplace-category',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-marketplace'),
					secondary: () => import('@views/v-marketplace-category'),
				},
			},
			{
				path: 'marketplace/detail/:productId',
				name: 'marketplace-detail',
				props: {
					primary: true,
				},
				meta: { isProductPack: false, isFullWidth: true },
				components: {
					primary: () => import('@views/v-marketplace-detail'),
				},
			},
			{
				path: 'marketplace/redirection/:productId',
				name: 'marketplace-redirection',
				props: { primary: true },
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-marketplace-redirection'),
				},
			},
			{
				path: 'marketplace/detail/pack/:productId',
				name: 'marketplace-pack-detail',
				props: {
					primary: true,
				},
				meta: { isProductPack: true, isFullWidth: true },
				components: {
					primary: () => import('@views/v-marketplace-pack-detail'),
				},
			},
			{
				path: 'customer-service',
				name: 'customer-service',
				props: { primary: true },
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-customer-service'),
				},
			},
			{
				path: 'customer-online',
				name: 'customer-online',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-customer-service'),
					secondary: () => import('@views/v-customer-online'),
				},
			},
			{
				path: 'customer-offices',
				name: 'customer-offices',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-customer-offices'),
				},
			},
			{
				path: 'sirvase',
				name: 'sirvase',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade', isFullWidth: true },
				components: {
					primary: () => import('@views/v-sirvase'),
				},
			},
			{
				path: 'sirvase/welcome',
				name: 'sirvase-welcome',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-sirvase-welcome'),
				},
			},
			{
				path: 'sirvase-dashboard',
				name: 'sirvase-dashboard',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-sirvase-dashboard'),
				},
			},
			{
				path: 'sirvase-detail/:requestId',
				name: 'sirvase-detail',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-sirvase-detail'),
				},
			},
			{
				path: 'sirvase-create/:typologyId',
				name: 'sirvase-create',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-sirvase-create'),
				},
			},
			{
				path: 'feedback',
				name: 'feedback',
				props: { primary: true },
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-feedback'),
				},
			},
			{
				path: 'product/card/credit-card/:productId/movement/:movementId/deferral/redirectToGlobal/:redirectToGlobal',
				name: 'cbnk-card-installment-movement',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-card-installment-movement'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'product/:productType/:familyId/:productId/movement/:movementId',
				name: 'cbnk-movement',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-movement'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'product/:productType/:familyId/:productId/movement/:movementId',
				name: 'movement',
				props: {
					primary: true,
					secondary: true,
				},

				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-movement'),
				},
			},
			{
				path: 'product/confirming-invoice/:productId/financings',
				name: 'confirming-invoice-financings',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-confirming-invoice-financings'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'ontime/product/:productType/:familyId/:productId/movement/:movementId',
				name: 'cbnk-ontime-movement',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-movement'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'ontime/product/:productType/:familyId/:productId/movement/:movementId',
				name: 'ontime-movement',
				props: {
					primary: true,
					secondary: true,
				},

				components: {
					primary: () => import('@views/v-ontime-dashboard'),
					secondary: () => import('@views/v-movement'),
				},
			},
			{
				path: 'product/:familyId/:productId/withholdings',
				name: 'withholdings',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-withholdings'),
				},
			},
			{
				path: 'product/:familyId/:productId/withholdings',
				name: 'cbnk-withholdings',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-withholdings'),
				},
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
			},
			{
				path: 'product/:familyId/:productId',
				name: 'cbnk-product',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-product'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'product/:familyId/:productId',
				name: 'product',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-product'),
				},
			},
			{
				path: 'product/:familyId/:productId/imposition/:movementId',
				name: 'cbnk-imposition',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-imposition'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'product/:familyId/:productId/imposition/:movementId',
				name: 'imposition',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-imposition'),
				},
			},

			{
				path: 'product/financed-operation/:productId/amortize',
				name: 'financed-operation-amortize',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-financed-operation-amortize'),
				},
			},

			{
				path: 'product/financed-operation/:productId',
				name: 'financed-operation-detail',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-financed-operation-detail'),
				},
			},
			{
				path: 'product/:familyId/:productId/asset/:assetId',
				name: 'asset',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-asset'),
				},
			},
			{
				path: 'product/:familyId/:productId/investment-asset/:assetId',
				name: 'investment-asset',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-investment-asset'),
				},
			},
			{
				path: 'product/:familyId/:productId/composition/:type/:tab?',
				name: 'composition',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-composition'),
				},
			},
			{
				path: 'product/:familyId/search-movements/:productId/:exporting',
				name: 'cbnk-search-movements',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-search-movements'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'product/:familyId/search-movements/:productId/:exportType/:exporting',
				name: 'search-movements',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-search-movements'),
				},
			},
			{
				path: 'product/:familyId/filter-investment/:productId/',
				name: 'cbnk-filter-investment',
				props: { primary: true },
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-filter-investment'),
				},
			},
			{
				path: 'product/:familyId/filter-investment/:productId/',
				name: 'filter-investment',
				props: { primary: true },
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-filter-investment'),
				},
			},
			{
				path: 'product/:familyId/:productId/detail',
				name: 'product-detail-cbnk',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-product-detail'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'product/:familyId/:productId/detail',
				name: 'product-detail',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade' },
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-product-detail'),
				},
			},
			{
				path: 'product/:familyId/:productId/investment-detail',
				name: 'cbnk-investment-product-detail',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
				components: {
					primary: () => import('@views/v-cbnk-product-detail'),
				},
			},
			{
				path: 'product/:familyId/:productId/investment-detail',
				name: 'investment-product-detail',
				props: { primary: true },
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
				components: {
					primary: () => import('@views/v-product-detail'),
				},
			},
			{
				path: 'product/investment/composition/:productId',
				name: 'cbnk-investment-detail-composition',
				props: () => ({
					primary: true,
					productType: 'composition',
				}),
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-investment-detail'),
				},
			},
			{
				path: 'product/investment/movement/:productId',
				name: 'cbnk-investment-detail-movement',
				props: () => ({
					primary: true,
					productType: 'movement',
				}),
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-investment-detail'),
				},
			},
			{
				path: 'product/investment/documents/:productId',
				name: 'investment-documents',
				props: {
					primary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-investment-documents'),
				},
			},
			{
				path: 'product/account/:productId/operative/:operativeType',
				name: 'account-operative',
				props: {
					primary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-account-limits'),
				},
			},
			{
				path: 'product/:familyId/:productId/operative/:operativeType/:eventId?',
				name: 'cbnk-card-operative',
				props: {
					primary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-card-operative'),
				},
			},
			{
				path: 'product/:familyId/:productId/operative/:operativeType',
				name: 'card-operative',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade' },
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-card-operative'),
				},
			},
			{
				path: 'product/:familyId/:productId/simulation',
				name: 'cbnk-settlement-simulation',
				props: {
					primary: true,
				},
				meta: { transition: 'fade', isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-settlement-simulation'),
				},
			},
			{
				path: 'product/:familyId/:productId/simulation',
				name: 'settlement-simulation',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade' },
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-settlement-simulation'),
				},
			},
			{
				path: 'product/:familyId',
				name: 'cbnk-product-group',
				props: {
					primary: (route) => ({
						familyId: route.params.familyId,
						investmentAmountFetched: toBoolean(route.query.investmentAmountFetched),
					}),
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-product-group'),
				},
			},
			{
				path: 'product/:familyId',
				name: 'product-group',
				props: {
					primary: (route) => ({
						familyId: route.params.familyId,
						investmentAmountFetched: toBoolean(route.query.investmentAmountFetched),
					}),
					secondary: (route) => ({
						familyId: route.params.familyId,
						investmentAmountFetched: toBoolean(route.query.investmentAmountFetched),
					}),
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-product-group'),
				},
			},
			{
				path: 'product/:familyId/:productId/profiles',
				name: 'cbnk-product-profiles',
				props: {
					primary: true,
				},
				meta: { isNavDisabled: true, isFullWidth: true, isNavButtonDisabled: true },
				components: {
					primary: () => import('@views/v-product-profiles'),
				},
			},
			{
				path: 'product/:familyId/:productId/profiles',
				name: 'product-profiles',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isNavDisabled: true },
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-product-profiles'),
				},
			},
			{
				path: 'product/:familyId/:productId/debits',
				name: 'cbnk-debits',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-debits'),
				},
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
			},
			{
				path: 'product/:familyId/:productId/debits',
				name: 'debits',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-debits'),
				},
			},
			{
				path: 'product/:familyId/:productId/debits/creditor/:creditorId',
				name: 'cbnk-creditor-detail',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-creditor-detail'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'product/:familyId/:productId/debits/creditor/:creditorId',
				name: 'creditor-detail',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-creditor-detail'),
				},
			},
			{
				path: 'product/:familyId/:productId/debits/:movementId/:creditorId?',
				name: 'cbnk-movement-debit',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-movement-debit'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'product/:familyId/:productId/debits/:movementId/:creditorId?',
				name: 'cbnk-movement-debit',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-movement-debit'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'product/:familyId/:productId/debits/:movementId/:creditorId?',
				name: 'movement-debit',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-movement-debit'),
				},
			},
			{
				path: 'premium/:familyId',
				name: 'cbnk-premium',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-premium'),
				},
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
			},
			{
				path: 'premium/:familyId',
				name: 'premium',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-premium'),
				},
			},
			{
				path: 'amortization-table/:productId',
				name: 'cbnk-amortization-table',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-amortization-table'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},

			{
				path: 'amortization-table/:productId',
				name: 'amortization-table',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-amortization-table'),
				},
			},
			{
				path: 'product/:familyId/:productId/receipts-table',
				name: 'cbnk-receipts-table',
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-receipts-table'),
				},
				meta: {
					isFullWidth: true,
					transition: 'fade',
				},
			},
			{
				path: 'product/:familyId/:productId/receipts-table',
				name: 'receipts-table',
				props: {
					primary: true,
					secondary: true,
				},
				components: {
					primary: () => import('@views/v-global'),
					secondary: () => import('@views/v-receipts-table'),
				},
			},
			{
				path: 'personal-area',
				name: 'personal-area',
				props: { primary: true },
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-personal-area'),
				},
			},
			{
				path: 'document-management',
				name: 'document-management',
				props: { primary: true },
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-document-management'),
				},
			},
			{
				path: 'document-management/list',
				name: 'document-management-list',
				props: { primary: true },
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-document-list'),
				},
			},
			{
				path: 'document-management/detail/:id',
				name: 'document-management-detail',
				props: { primary: true },
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-document-detail'),
				},
			},
			{
				path: 'personal-area/farmaSmart',
				name: 'farmaSmart',
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-farmaSmart.vue'),
				},
			},
			{
				path: 'personal-area/notifications',
				name: 'cbnk-notifications',
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-notifications'),
				},
			},
			{
				path: 'security-and-privacy',
				name: 'security-and-privacy',
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-security-and-privacy'),
				},
			},
			{
				path: 'security-and-privacy/change-password',
				name: 'change-password',
				components: {
					primary: () => import('@views/v-change-password'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'security-and-privacy/gdpr',
				name: 'gdpr',
				components: {
					primary: () => import('@views/v-gdpr'),
				},
				meta: {
					isFullWidth: true,
					isNavDisabled: true,
				},
			},
			{
				path: 'security-and-privacy/block',
				name: 'block',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isNavDisabled: true, isFullWidth: true },
				components: {
					primary: () => import('@views/v-block'),
				},
			},
			{
				path: 'personal-area/devices-list',
				name: 'devices-list',
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-devices-list'),
				},
			},
			{
				path: 'personal-area/devices-list/device-sessions/:deviceId',
				name: 'device-sessions',
				meta: { isFullWidth: true },
				props: {
					primary: true,
				},
				components: {
					primary: () => import('@views/v-cbnk-device-sessions'),
				},
			},
			{
				path: 'personal-area/personal-data',
				name: 'personal-data',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-personal-data'),
				},
			},
			{
				path: 'personal-area/personal-data-edit',
				name: 'personal-data-edit',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-personal-data-edit'),
				},
			},

			{
				path: 'personal-area/identity-document-capture/:blocked?',
				name: 'identity-document-capture',
				props: (route) => ({
					isBlocked: route.params.blocked ? route.params.blocked === 'blocked' : false,
				}),
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-identity-document-capture'),
				},
			},
			{
				path: 'personal-area/mas-cbnk',
				name: 'mas-cbnk',
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-mas-cbnk'),
				},
			},
			{
				path: 'money-movements/:type?',
				name: 'money-movements',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-money-movements'),
				},
			},
			{
				path: 'multi-transfers/:type?/:action?/:transferId?/:productId?',
				name: 'multi-transfers',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-multi-transfer'),
				},
			},
			/*{
				path: 'multi-transfers/:type?',
				name: 'multi-transfers-redirect',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-multi-transfer'),
				},
			},*/
			{
				path: 'favorite-accounts',
				name: 'favorite-accounts',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-favorite-accounts'),
				},
			},
			{
				path: 'transfers',
				name: 'transfers',
				props: { primary: true },
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-transfers'),
				},
			},
			{
				path: 'transfer/:action/:type?/:transferId?/:productId?',
				name: 'transfer',
				props: { primary: true },
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-transfer'),
				},
			},
			{
				path: 'my-transfers/:type',
				name: 'my-transfers',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-my-transfers'),
				},
			},
			{
				path: 'my-transfers/:productId/:type/:transferId?',
				name: 'transfer-detail',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-transfer-detail'),
				},
			},
			{
				path: 'bizum',
				name: 'bizum',
				props: {
					primary: true,
					secondary: true,
				},
				meta: {
					transition: 'fade',
					isFullWidth: true,
					hasTransferOptions: true,
				},
				components: {
					primary: () => import('@views/v-bizum'),
				},
			},
			{
				path: 'bizum/welcome',
				name: 'bizum-welcome',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, hasTransferOptions: true },
				components: {
					primary: () => import('@views/v-bizum-welcome'),
				},
			},
			{
				path: 'bizum/register/:productId?',
				name: 'bizum-register',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-register'),
				},
			},
			{
				path: 'bizum/settings',
				name: 'bizum-settings',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-settings'),
				},
			},
			{
				path: 'bizum/connections',
				name: 'bizum-connections',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-connections'),
				},
			},
			{
				path: 'bizum/connections-detail/:consentId',
				name: 'bizum-connections-detail',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-connections-detail'),
				},
			},
			{
				path: 'bizum/connections-history/:consentId',
				name: 'bizum-connections-history',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-connections-history'),
				},
			},
			{
				path: 'bizum/subscriptions',
				name: 'bizum-subscriptions',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-subscriptions'),
				},
			},
			{
				path: 'bizum/subscriptions/detail/:subscriptionId',
				name: 'bizum-subscriptions-detail',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-subscriptions-detail'),
				},
			},
			{
				path: 'bizum/dashboard',
				name: 'bizum-dashboard',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, hasTransferOptions: true },
				components: {
					primary: () => import('@views/v-bizum-dashboard'),
				},
			},
			{
				path: 'bizum/details',
				name: 'bizum-details',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-details'),
				},
			},
			{
				path: 'bizum/help',
				name: 'bizum-help',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-help'),
				},
			},
			{
				path: 'bizum/selae',
				name: 'bizum-selae',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-selae'),
				},
			},
			{
				path: 'bizum/selae-detail',
				name: 'bizum-selae-detail',
				props: {
					primary: true,
					secondary: true,
				},
				meta: {
					transition: 'fade',
					isFullWidth: true,
					isNavDisabled: true,
					primary: (route) => ({
						relatedCustomerData: route.state || { prueba: 'hola' },
					}),
				},

				components: {
					primary: () => import('@views/v-bizum-selae-detail'),
				},
			},
			{
				path: 'bizum/unregister',
				name: 'bizum-unregister',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-unregister'),
				},
			},
			{
				path: 'bizum/movement/:movementId',
				name: 'bizum-movement',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-movement'),
				},
			},
			{
				path: 'bizum/transfer/:action?/:movementId?',
				name: 'bizum-transfer',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-bizum-transfer'),
				},
				children: [
					{
						path: 'contacts',
						name: 'bizum-contacts',
						props: true,
						meta: { hasStateSlot: true },
						component: () => import('@views/v-bizum-contacts'),
					},
					{
						path: 'ongs',
						name: 'bizum-ongs',
						props: true,
						meta: { hasStateSlot: true },
						component: () => import('@views/v-bizum-ongs'),
					},
				],
			},
			{
				path: 'communications/:type?',
				name: 'communications',
				props: { primary: true },
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-communications'),
				},
			},
			{
				path: 'communications/:type/:messageId',
				name: 'communication-detail',
				props: { primary: true },
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-communications'),
				},
			},
			{
				path: 'signatures/:type/closable/:isClosable?',
				name: 'signatures',
				props: (route) => ({
					type: route.params.type || 'signed',
					isClosable: route.params.isClosable ? route.params.isClosable === 'true' : true,
				}),
				meta: { isFullWidth: true },
				components: { primary: () => import('@views/v-signatures') },
			},
			{
				path: 'blocking-campaign',
				name: 'blocking-campaign',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isNavDisabled: true },
				components: {
					primary: () => import('@views/v-blocking-campaign'),
					secondary: () => import('@views/v-dynamic-page'),
				},
			},
			{
				path: 'signatures/:type/:signatureId',
				name: 'signature-detail',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-signature-detail'),
				},
			},
			{
				path: 'correos-cash-dashboard',
				name: 'correos-cash-dashboard',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-correos-cash-dashboard'),
				},
			},
			{
				path: 'correos-cash-deposit',
				name: 'correos-cash-deposit',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-correos-cash-deposit'),
				},
			},
			{
				path: 'correos-cash-detail/:depositId?/:qrId?',
				name: 'correos-cash-detail',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-correos-cash-detail'),
				},
			},
			{
				path: 'correos-cash/qr/:depositId/:qrId',
				name: 'correos-cash-qr',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-correos-cash-qr'),
				},
			},
			{
				path: 'profiles/closable/:isClosable?',
				name: 'profiles',
				props: (route) => ({
					isClosable: route.params.isClosable ? route.params.isClosable === 'true' : true,
				}),
				meta: { transition: 'fade', isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-profiles'),
				},
			},
			{
				path: 'profiles/dashboard/closable/:isClosable?',
				name: 'cbnk-profiles-dashboard',
				props: (route) => ({
					isClosable: route.params.isClosable ? route.params.isClosable === 'true' : true,
				}),
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-cbnk-profiles-dashboard'),
				},
			},
			{
				path: 'profiles/dashboard/closable/:isClosable?',
				name: 'profiles-dashboard',
				props: (route) => ({
					isClosable: route.params.isClosable ? route.params.isClosable === 'true' : true,
				}),
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-profiles-dashboard'),
				},
			},
			{
				path: 'profiles/welcome',
				name: 'cbnk-profiles-welcome',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-profiles-welcome'),
				},
			},
			{
				path: 'profiles/welcome',
				name: 'profiles-welcome',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-profiles-welcome'),
				},
			},
			{
				path: 'profiles/create/:profileId?',
				name: 'cbnk-profiles-create',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-profiles-create'),
				},
			},
			{
				path: 'profiles/create/:profileId?',
				name: 'profiles-create',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-profiles-create'),
				},
			},
			{
				path: 'ontime',
				name: 'ontime',
				props: {
					primary: true,
					secondary: true,
				},
				meta: { transition: 'fade', isFullWidth: true },
				components: {
					primary: () => import('@views/v-ontime'),
				},
			},
			{
				path: 'ontime/dashboard',
				name: 'cbnk-ontime-dashboard',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: false },
				components: {
					primary: () => import('@views/v-cbnk-ontime-dashboard'),
				},
			},
			{
				path: 'ontime/dashboard',
				name: 'ontime-dashboard',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true },
				components: {
					primary: () => import('@views/v-ontime-dashboard'),
				},
			},
			{
				path: 'ontime/welcome',
				name: 'cbnk-ontime-welcome',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-ontime-welcome'),
				},
			},
			{
				path: 'ontime/welcome',
				name: 'ontime-welcome',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-ontime-welcome'),
				},
			},
			{
				path: 'ontime/create',
				name: 'cbnk-ontime-create',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-ontime-create'),
				},
			},
			{
				path: 'ontime/create',
				name: 'ontime-create',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-ontime-create'),
				},
			},
			{
				path: 'ontime/filter',
				name: 'cbnk-ontime-filter',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-cbnk-ontime-filter'),
				},
			},
			{
				path: 'ontime/filter',
				name: 'ontime-filter',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-ontime-filter'),
				},
			},
			{
				path: 'limits-manage/:productId',
				name: 'limits-manage',
				props: {
					primary: true,
				},
				meta: { isFullWidth: true, isNavDisabled: true },
				components: {
					primary: () => import('@views/v-limits-manage'),
				},
			},
		],
	},
];
